import { Navigate, Route, Routes } from 'react-router';
import { useCurrentUser } from './api/session';
import { AppShell } from './layout/AppShell';
import { RequireAuth } from './layout/RequireAuth';
import { AttendancePage } from './pages/AttendancePage';
import { AccessPage } from './pages/admin/AccessPage';
import { SecurityPage } from './pages/admin/SecurityPage';
import { SystemStatusPage } from './pages/admin/SystemStatusPage';
import { CabinetPage } from './pages/CabinetPage';
import { ExportsPage } from './pages/ExportsPage';
import { ImportsPage } from './pages/ImportsPage';
import { LoginPage } from './pages/LoginPage';
import { MetricsPage } from './pages/MetricsPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { OrgPage } from './pages/OrgPage';
import { PayrollPage } from './pages/PayrollPage';
import { RegulationsPage } from './pages/RegulationsPage';
import { RoleGroupPage } from './pages/RoleGroupPage';

/** Главная: свой кабинет у сотрудника, оргструктура у технического пользователя. */
function Home() {
  const me = useCurrentUser();
  return <Navigate to={me.data?.employeeId ? '/me' : '/org'} replace />;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route index element={<Home />} />
        <Route path="/me" element={<CabinetPage own />} />
        <Route path="/employees/:id" element={<CabinetPage key="employee" />} />
        <Route path="/org" element={<OrgPage />} />
        <Route path="/metrics" element={<MetricsPage />} />
        <Route path="/attendance" element={<AttendancePage />} />
        <Route path="/payroll" element={<PayrollPage />} />
        <Route path="/exports" element={<ExportsPage />} />
        <Route path="/imports" element={<ImportsPage />} />
        <Route path="/regulations" element={<RegulationsPage />} />
        <Route path="/regulations/:id" element={<RoleGroupPage />} />
        <Route path="/admin/access" element={<AccessPage />} />
        <Route path="/admin/security" element={<SecurityPage />} />
        <Route path="/admin/system" element={<SystemStatusPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
